export class SmartyStreetsService {
  constructor(axios, apiUrl, apiAddressUrl, apiKey) {
    this.$axios = axios;
    this.$apiUrl = apiUrl,
    this.$apiAddressUrl = apiAddressUrl,
    this.$apiKey = apiKey;
  }

  async lookup(address) {
    const results = await this.$axios
      .get(this.$apiUrl, {
        params: {
          key: this.$apiKey,
          search: address,
          source: "all"
        }
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return {error: error, response: error.response.data };
      });

    return results;
  }
  
  async validateSelectedAddress(address) {
    const results = await this.$axios
      .get(this.$apiAddressUrl, {
        params: {
          key: this.$apiKey,
          street: address.street_line,
          city: address.city,
          state: address.state,
          zipcode: address.zipcode,
          match: "enhanced",
        }
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        return {error: error, response: error.response.data };
      });
    return results;
  }
}
